export default __webpack_public_path__ + "static/media/23.26e1266b.jpg";